import React, { useState } from "react";
import { Switch } from "components/ui/switch";
import EquipmentCard from "./EquipmentCard";

const EquipmentMatchListings = ({ matchedEquipment = [], crewEquipments = [], selectedEquipmentIds = [], onEquipmentSelection }) => {
  const [showCrewEquipments, setShowCrewEquipments] = useState(false);

  // Determine which list to display based on the switch state
  const displayList = showCrewEquipments ? crewEquipments : matchedEquipment;
  const listCount = displayList.length;

  const handleEquipmentToggle = (equipmentId) => {
    // Find the item in the current list
    const item = displayList.find(e => e.equipment_id === equipmentId);

    // Check if the item is unavailable
    const isUnavailable = item?.is_available === 0;

    // If it's unavailable, don't allow selection
    if (isUnavailable) {
      console.warn("This item is unavailable and cannot be selected.");
      return;
    }

    const isSelected = selectedEquipmentIds.includes(equipmentId);
    if (onEquipmentSelection) {
      onEquipmentSelection(equipmentId, !isSelected);
    }
  };

  return (
    <div className="border rounded-2xl p-6">
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <p className="text-2xl font-semibold">
            {/* Update header text based on which list is shown */}
            {showCrewEquipments
              ? `Crew Equipments (${listCount})`
              : `Equipment Matches (${listCount})`
            }
          </p>
          <div className="text-sm hidden md:flex items-center gap-2">
            <Switch
              id="hide-beige-profiles"
              checked={showCrewEquipments}
              onCheckedChange={setShowCrewEquipments}
              className={`data-[state=checked]:bg-button-coloured data-[state=unchecked]:bg-muted data-[state=unchecked]:bg-accent relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-0 transition-colors duration-200`}
            />
            <p className="text-sm font-semibold text-foreground">Crew Equipments</p>
          </div>
        </div>
        <p className="text-muted-foreground text-sm font-normal leading-5">
          {/* Update description based on which list is shown */}
          {showCrewEquipments
            ? `Displaying ${listCount} equipment item${listCount !== 1 ? 's' : ''} owned by the selected crew members.`
            : `Based on your project's unique needs, our AI has identified ${listCount} equipment item${listCount !== 1 ? 's' : ''} that ${listCount !== 1 ? 'are' : 'is'} available on your event date and near your location.`
          }
        </p>
        <div className="text-sm flex md:hidden items-center gap-2 mt-2">
          <Switch
            id="hide-beige-profiles"
            checked={showCrewEquipments}
            onCheckedChange={setShowCrewEquipments}
            className={`data-[state=checked]:bg-button-coloured data-[state=unchecked]:bg-muted data-[state=unchecked]:bg-accent relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-0 transition-colors duration-200`}
          />
          <p className="text-sm font-semibold text-foreground">Crew Equipments</p>
        </div>
      </div>

      {listCount === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <p className="text-lg font-semibold">
            {showCrewEquipments ? "No crew equipment found" : "No equipment matches found"}
          </p>
          <p className="text-sm mt-2">Try adjusting your requirements or equipment categories</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Use the dynamically selected list for mapping */}
          {displayList.map((equipment) => (
            <EquipmentCard
              key={equipment.equipment_id}
              equipment={equipment}
              isSelected={selectedEquipmentIds.includes(equipment.equipment_id)}
              onToggleSelect={() => handleEquipmentToggle(equipment.equipment_id)}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default EquipmentMatchListings;
